// LimpackFlex (tienda v5) — página pública del servicio de envío en el día.
// Ruta /limpackflex (+ dev alias). Acento TEAL. Modelada sobre Barrios.jsx (misma estética v5).
// Reusa shared: TopNav(teal) / Breadcrumb / Footer / BottomNav / MiniBar.
// Reglas landing: sin marcas de proveedores, sin "más barato que el súper". Precios con IVA.
// Números de envío alineados con calcular_envio_oneshot / envio_tarifas (MVD desde $149, gratis
// ≥$1.000 · Canelones extendida $199, gratis ≥$2.000 · interior Tres Cruces $99, gratis ≥$1.000 ·
// corte 16h lun-vie, sábado 10h, domingo no reparte).
import { Link } from 'react-router-dom';
import { TopNav, Breadcrumb, Footer, BottomNav, MiniBar } from '../../components/tienda-v5';
import { TV5_ROUTES, TV5_EXTERNAL } from '../../components/tienda-v5/routes';

const KPIS = [
  { num: 'Hoy', label: 'Llega el mismo día' },
  { num: '$0', label: 'Envío gratis desde $1.000' },
  { num: '16 h', label: 'Corte para que llegue hoy' },
];

const PASOS = [
  { emoji: '🛒', h: 'Armá tu pedido', p: 'Elegí lo que necesitás en la Tienda. Productos sueltos, sin suscripción ni mínimos.' },
  { emoji: '📍', h: 'Marcá tu dirección', p: 'La ubicás en el mapa para que llegue justo a tu puerta — clave en Canelones.' },
  { emoji: '💳', h: 'Pagás seguro', p: 'Con Mercado Pago: tarjeta, débito, Abitab, Redpagos o transferencia.' },
  { emoji: '🚚', h: 'Te llega', p: 'Hoy o mañana según la hora. Te avisamos por WhatsApp cuando tu pedido sale.' },
];

const CORTES = [
  { emoji: '📅', color: 'teal', dia: 'Lunes a viernes', p: 'Pedí antes de las 16 h y llega hoy. Después de las 16 h, llega mañana.' },
  { emoji: '🌤️', color: 'gold', dia: 'Sábados', p: 'Pedí antes de las 10 de la mañana y llega el mismo sábado. Después de las 10, llega el lunes.' },
  { emoji: '💤', color: 'green', dia: 'Domingos', p: 'No repartimos. Lo que pidas queda para el lunes.' },
];

const ZONAS = [
  { emoji: '🏙️', color: 'teal', z: 'Montevideo', precio: 'Desde $149', p: 'LimpackFlex en el día por toda la ciudad. Según tu barrio: Zona Verde $149 · Zona Celeste $169 · Zona Azul $189. Envío gratis a partir de $1.000.' },
  { emoji: '🌊', color: 'green', z: 'Canelones · Zona Costa', precio: '$199', p: 'Ciudad de la Costa y barrios privados del corredor Camino de los Horneros (barrios privados $290). Envío gratis a partir de $2.000.' },
  { emoji: '📦', color: 'gold', z: 'Resto del país', precio: '$99', p: 'Despacho a la Terminal Tres Cruces (gratis desde $1.000). La encomienda la pagás al retirar; te pedimos la cédula.' },
];

const WA_DUDAS = `${TV5_EXTERNAL.whatsapp}?text=${encodeURIComponent('Hola! Tengo una duda sobre los envíos LimpackFlex.')}`;

export default function LimpackFlex() {
  return (
    <div className="tv5-page-limpackflex">
      <style>{LF_CSS}</style>

      <TopNav active="limpackflex" accent="teal" />
      <Breadcrumb backHref={TV5_ROUTES.home} backLabel="Home" current="LimpackFlex" />

      <main>
        {/* HERO */}
        <section className="lf-hero">
          <span className="lf-eyebrow">⚡ LimpackFlex</span>
          <h1>Tu pedido de limpieza,<br />llega hoy.</h1>
          <p>Comprá lo que necesitás y te lo llevamos el mismo día en Montevideo. Pedí antes de las 16 h y llega hoy; más tarde, llega mañana. Envío gratis desde $1.000.</p>
          <div className="lf-hero-cta">
            <Link to={TV5_ROUTES.tienda} className="lf-btn-primary">Comprá ahora →</Link>
            <a href={WA_DUDAS} target="_blank" rel="noopener noreferrer" className="lf-btn-ghost">Consultar por WhatsApp</a>
          </div>
        </section>

        {/* KPIS */}
        <div className="lf-kpis">
          {KPIS.map((k) => (
            <div className="lf-kpi" key={k.label}>
              <div className="lf-kpi-num">{k.num}</div>
              <div className="lf-kpi-label">{k.label}</div>
            </div>
          ))}
        </div>

        {/* CÓMO FUNCIONA */}
        <section className="lf-seccion">
          <h2>Cómo funciona</h2>
          <p className="lf-seccion-sub">Cuatro pasos y listo. Sin suscripción, pagás solo lo que llevás.</p>
          <div className="lf-info-cards lf-info-cards--4">
            {PASOS.map((c) => (
              <div className="lf-info-card" key={c.h}>
                <span className="lf-info-emoji">{c.emoji}</span>
                <h3>{c.h}</h3>
                <p>{c.p}</p>
              </div>
            ))}
          </div>
        </section>

        {/* CUÁNDO LLEGA */}
        <section className="lf-seccion">
          <h2>Cuándo llega</h2>
          <p className="lf-seccion-sub">Cuanto antes pedís, antes llega. Estos son los cortes.</p>
          {CORTES.map((g) => (
            <div className={`lf-grupo lf-grupo--${g.color}`} key={g.dia}>
              <div className="lf-grupo-emoji">{g.emoji}</div>
              <div className="lf-grupo-body">
                <h3>{g.dia}</h3>
                <p>{g.p}</p>
              </div>
            </div>
          ))}
        </section>

        {/* ZONAS Y ENVÍO */}
        <section className="lf-seccion">
          <h2>Zonas y envío</h2>
          <p className="lf-seccion-sub">A dónde llegamos y desde cuánto es gratis. El costo exacto lo ves en el checkout según tu dirección.</p>
          <div className="lf-zonas">
            {ZONAS.map((z) => (
              <div className={`lf-zona lf-zona--${z.color}`} key={z.z}>
                <div className="lf-zona-top">
                  <span className="lf-zona-emoji">{z.emoji}</span>
                  <span className="lf-zona-precio">{z.precio}</span>
                </div>
                <h3>{z.z}</h3>
                <p>{z.p}</p>
              </div>
            ))}
          </div>
          <p className="lf-nota">Precios con IVA incluido. El envío se calcula por tu dirección al finalizar la compra.</p>
        </section>

        {/* CTA FINAL */}
        <div className="lf-cta-final">
          <div>
            <div className="lf-cta-titulo">⚡ Envíos en el día</div>
            <h3>Comprá ahora y elegí LimpackFlex</h3>
            <p>Armá tu pedido, marcá tu dirección en el mapa y pagá con Mercado Pago. Si comprás antes de las 16 h, te llega hoy.</p>
            <p className="lf-cta-empresa">¿Sos empresa? <Link to={TV5_ROUTES.empresas}>Mirá los planes para empresas →</Link></p>
          </div>
          <Link to={TV5_ROUTES.tienda} className="lf-cta-btn">Ir a la Tienda →</Link>
        </div>
      </main>

      <MiniBar checkoutHref={TV5_ROUTES.checkout} />
      <Footer accent="teal" />
      <BottomNav active="tienda" />
    </div>
  );
}

const LF_CSS = `
.tv5-page-limpackflex {
  --lf-navy:#1A3461; --lf-teal:#00A8B5; --lf-gold:#C5A059; --lf-green:#10B981;
  --lf-bg:#0A1424; --lf-card:rgba(255,255,255,0.04); --lf-border:rgba(255,255,255,0.08);
  --lf-text:#F8F6F1; --lf-muted:rgba(248,246,241,0.65); --lf-dim:rgba(248,246,241,0.45);
  --safe-bottom:env(safe-area-inset-bottom, 0px);
  background:var(--lf-bg); color:var(--lf-text); min-height:100vh; position:relative;
  overflow-x:clip; max-width:100%;
  font-family:'Inter',-apple-system,BlinkMacSystemFont,sans-serif;
  padding-bottom:calc(72px + var(--safe-bottom));
}
.tv5-page-limpackflex::before {
  content:''; position:fixed; inset:0; pointer-events:none; z-index:0;
  background:
    radial-gradient(circle at 20% 10%, rgba(0,168,181,0.14) 0%, transparent 42%),
    radial-gradient(circle at 85% 55%, rgba(91,189,216,0.08) 0%, transparent 42%);
}
.tv5-page-limpackflex main { position:relative; z-index:1; }
@media (min-width:900px){ .tv5-page-limpackflex { padding-bottom:0; } }

/* HERO */
.tv5-page-limpackflex .lf-hero { padding:44px 20px 22px; text-align:center; max-width:900px; margin:0 auto; }
.tv5-page-limpackflex .lf-eyebrow { display:inline-block; color:var(--lf-teal); font-size:11px; font-weight:800; letter-spacing:0.15em; text-transform:uppercase; padding:6px 14px; background:rgba(0,168,181,0.1); border:1px solid rgba(0,168,181,0.3); border-radius:999px; margin-bottom:14px; }
.tv5-page-limpackflex .lf-hero h1 { font-size:clamp(30px, 6.5vw, 50px); font-weight:800; letter-spacing:-0.03em; line-height:1.04; margin-bottom:12px; background:linear-gradient(135deg, var(--lf-text) 0%, var(--lf-teal) 100%); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
.tv5-page-limpackflex .lf-hero p { color:var(--lf-muted); font-size:15px; max-width:580px; margin:0 auto 22px; line-height:1.6; }
.tv5-page-limpackflex .lf-hero-cta { display:flex; gap:12px; justify-content:center; flex-wrap:wrap; }
.tv5-page-limpackflex .lf-btn-primary { background:linear-gradient(135deg, var(--lf-teal), #0090a0); color:#fff; padding:14px 26px; border-radius:12px; font-weight:800; font-size:15px; text-decoration:none; min-height:48px; display:inline-flex; align-items:center; box-shadow:0 8px 22px rgba(0,168,181,0.3); transition:transform 0.15s; }
.tv5-page-limpackflex .lf-btn-ghost { background:rgba(255,255,255,0.05); border:1px solid var(--lf-border); color:var(--lf-text); padding:14px 22px; border-radius:12px; font-weight:700; font-size:14px; text-decoration:none; min-height:48px; display:inline-flex; align-items:center; }
@media (hover:hover){ .tv5-page-limpackflex .lf-btn-primary:hover { transform:translateY(-2px); } .tv5-page-limpackflex .lf-btn-ghost:hover { border-color:var(--lf-teal); color:var(--lf-teal); } }

/* KPIS */
.tv5-page-limpackflex .lf-kpis { max-width:800px; margin:0 auto; padding:20px; display:grid; grid-template-columns:repeat(3, 1fr); gap:12px; text-align:center; }
.tv5-page-limpackflex .lf-kpi { background:var(--lf-card); border:1px solid var(--lf-border); border-radius:14px; padding:20px 12px; }
.tv5-page-limpackflex .lf-kpi-num { font-size:clamp(22px, 4vw, 34px); font-weight:900; color:var(--lf-teal); letter-spacing:-0.02em; margin-bottom:4px; }
.tv5-page-limpackflex .lf-kpi-label { font-size:11px; color:var(--lf-muted); font-weight:600; line-height:1.35; }

/* SECCIÓN */
.tv5-page-limpackflex .lf-seccion { padding:38px 20px; max-width:1000px; margin:0 auto; }
.tv5-page-limpackflex .lf-seccion h2 { font-size:clamp(22px, 4vw, 32px); font-weight:800; letter-spacing:-0.02em; margin-bottom:8px; text-align:center; }
.tv5-page-limpackflex .lf-seccion-sub { text-align:center; color:var(--lf-muted); font-size:14px; margin:0 auto 30px; max-width:540px; line-height:1.5; }

/* INFO CARDS (pasos) */
.tv5-page-limpackflex .lf-info-cards { display:grid; gap:12px; grid-template-columns:1fr; }
@media (min-width:360px){ .tv5-page-limpackflex .lf-info-cards--4 { grid-template-columns:repeat(2, 1fr); } }
@media (min-width:768px){ .tv5-page-limpackflex .lf-info-cards--4 { grid-template-columns:repeat(4, 1fr); } }
.tv5-page-limpackflex .lf-info-card { background:var(--lf-card); border:1px solid var(--lf-border); border-radius:14px; padding:22px 20px; }
.tv5-page-limpackflex .lf-info-emoji { font-size:28px; margin-bottom:10px; display:block; }
.tv5-page-limpackflex .lf-info-card h3 { font-size:16px; font-weight:800; margin-bottom:6px; letter-spacing:-0.01em; }
.tv5-page-limpackflex .lf-info-card p { color:var(--lf-muted); font-size:13px; line-height:1.5; }

/* GRUPO (cortes) */
.tv5-page-limpackflex .lf-grupo { background:var(--lf-card); border:1px solid var(--lf-border); border-radius:16px; padding:20px; margin-bottom:14px; display:flex; gap:16px; align-items:center; position:relative; overflow:hidden; }
.tv5-page-limpackflex .lf-grupo::before { content:''; position:absolute; top:0; left:0; bottom:0; width:4px; background:var(--lf-teal); }
.tv5-page-limpackflex .lf-grupo--gold::before { background:var(--lf-gold); }
.tv5-page-limpackflex .lf-grupo--green::before { background:var(--lf-green); }
.tv5-page-limpackflex .lf-grupo-emoji { width:48px; height:48px; border-radius:12px; background:rgba(0,168,181,0.12); border:1px solid rgba(0,168,181,0.3); display:flex; align-items:center; justify-content:center; font-size:24px; flex-shrink:0; }
.tv5-page-limpackflex .lf-grupo--gold .lf-grupo-emoji { background:rgba(197,160,89,0.12); border-color:rgba(197,160,89,0.3); }
.tv5-page-limpackflex .lf-grupo--green .lf-grupo-emoji { background:rgba(16,185,129,0.12); border-color:rgba(16,185,129,0.3); }
.tv5-page-limpackflex .lf-grupo-body h3 { font-size:16px; font-weight:800; letter-spacing:-0.01em; margin-bottom:3px; }
.tv5-page-limpackflex .lf-grupo-body p { font-size:13px; color:var(--lf-muted); line-height:1.5; }

/* ZONAS */
.tv5-page-limpackflex .lf-zonas { display:grid; gap:14px; }
@media (min-width:768px){ .tv5-page-limpackflex .lf-zonas { grid-template-columns:repeat(3, 1fr); } }
.tv5-page-limpackflex .lf-zona { background:var(--lf-card); border:1px solid var(--lf-border); border-radius:16px; padding:22px 20px; position:relative; overflow:hidden; }
.tv5-page-limpackflex .lf-zona::before { content:''; position:absolute; top:0; left:0; right:0; height:3px; background:linear-gradient(90deg, var(--lf-teal) 0%, rgba(0,168,181,0.3) 100%); }
.tv5-page-limpackflex .lf-zona--gold::before { background:linear-gradient(90deg, var(--lf-gold) 0%, rgba(197,160,89,0.3) 100%); }
.tv5-page-limpackflex .lf-zona--green::before { background:linear-gradient(90deg, var(--lf-green) 0%, rgba(16,185,129,0.3) 100%); }
.tv5-page-limpackflex .lf-zona-top { display:flex; align-items:center; justify-content:space-between; margin-bottom:10px; }
.tv5-page-limpackflex .lf-zona-emoji { font-size:26px; }
.tv5-page-limpackflex .lf-zona-precio { font-size:15px; font-weight:900; color:var(--lf-teal); background:rgba(0,168,181,0.1); border:1px solid rgba(0,168,181,0.25); padding:4px 12px; border-radius:999px; }
.tv5-page-limpackflex .lf-zona--gold .lf-zona-precio { color:var(--lf-gold); background:rgba(197,160,89,0.1); border-color:rgba(197,160,89,0.25); }
.tv5-page-limpackflex .lf-zona--green .lf-zona-precio { color:var(--lf-green); background:rgba(16,185,129,0.1); border-color:rgba(16,185,129,0.25); }
.tv5-page-limpackflex .lf-zona h3 { font-size:15px; font-weight:800; letter-spacing:-0.01em; margin-bottom:6px; line-height:1.25; }
.tv5-page-limpackflex .lf-zona p { color:var(--lf-muted); font-size:13px; line-height:1.5; }
.tv5-page-limpackflex .lf-nota { text-align:center; color:var(--lf-dim); font-size:12px; margin-top:18px; }

/* CTA FINAL */
.tv5-page-limpackflex .lf-cta-final { background:linear-gradient(135deg, rgba(0,168,181,0.14) 0%, rgba(0,168,181,0.04) 100%); border:1px solid rgba(0,168,181,0.3); border-radius:18px; padding:30px 24px; display:grid; gap:18px; max-width:900px; margin:20px auto 40px; }
@media (min-width:640px){ .tv5-page-limpackflex .lf-cta-final { grid-template-columns:1fr auto; align-items:center; gap:24px; } }
.tv5-page-limpackflex .lf-cta-titulo { font-size:11px; font-weight:800; letter-spacing:0.12em; text-transform:uppercase; color:var(--lf-teal); margin-bottom:8px; }
.tv5-page-limpackflex .lf-cta-final h3 { font-size:22px; font-weight:800; margin-bottom:6px; letter-spacing:-0.01em; }
.tv5-page-limpackflex .lf-cta-final > div > p { color:var(--lf-muted); font-size:13px; line-height:1.5; }
.tv5-page-limpackflex .lf-cta-empresa { margin-top:10px; font-size:13px; }
.tv5-page-limpackflex .lf-cta-empresa a { color:var(--lf-teal); text-decoration:none; font-weight:700; }
.tv5-page-limpackflex .lf-cta-btn { background:var(--lf-teal); color:#fff; padding:14px 26px; border-radius:12px; font-weight:800; font-size:15px; text-decoration:none; white-space:nowrap; display:inline-flex; align-items:center; justify-content:center; min-height:48px; box-shadow:0 8px 22px rgba(0,168,181,0.3); transition:transform 0.15s; }
@media (hover:hover){ .tv5-page-limpackflex .lf-cta-btn:hover { transform:translateY(-2px); } }

/* Mobile: más compacto (menos scroll) */
@media (max-width:640px){
  .tv5-page-limpackflex .lf-hero { padding:28px 18px 14px; }
  .tv5-page-limpackflex .lf-hero p { margin-bottom:18px; }
  .tv5-page-limpackflex .lf-seccion { padding:26px 16px; }
  .tv5-page-limpackflex .lf-seccion-sub { margin-bottom:18px; }
  .tv5-page-limpackflex .lf-kpis { padding:12px 16px; gap:8px; }
  .tv5-page-limpackflex .lf-kpi { padding:14px 8px; }
  .tv5-page-limpackflex .lf-info-card { padding:16px 14px; }
  .tv5-page-limpackflex .lf-info-emoji { font-size:24px; margin-bottom:6px; }
  .tv5-page-limpackflex .lf-info-card h3 { font-size:15px; }
  .tv5-page-limpackflex .lf-info-card p { font-size:12.5px; }
  .tv5-page-limpackflex .lf-grupo { padding:15px; gap:12px; margin-bottom:10px; }
  .tv5-page-limpackflex .lf-grupo-emoji { width:40px; height:40px; font-size:20px; }
  .tv5-page-limpackflex .lf-zona { padding:18px 16px; }
  .tv5-page-limpackflex .lf-cta-final { padding:24px 18px; margin:12px auto 28px; }
}

@media (prefers-reduced-motion:reduce){
  .tv5-page-limpackflex .lf-btn-primary, .tv5-page-limpackflex .lf-cta-btn { transition:none; }
}
`;
